import { C31IconCTABorderedProps } from './C31IconCTABordered.types';
import { IconCtaBordered } from '@ahc-digital/component-library';
import { CreateIconCTABorderedModel } from './C31IconCTABordered.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C31IconCTABorderedProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <IconCtaBordered
      {...CreateIconCTABorderedModel(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C31IconCTABorderedProps>(Default);
